define('NVT.anuualupdateform.anuualupdateformAddress.View'
, [
    'Backbone'
  , 'nvt_anuualupdateform_address.tpl'
  , 'Backbone.FormView'
  , 'GlobalViews.Message.View'
  ,	'underscore'
  ,	'jQuery'
  , 'Utils'
  ,	'NVT.anuualupdateform.anuualupdateform.SS2Model'


  ]
, function
  (
    Backbone
  , nvt_myassociatemulorg_address_tpl
  , BackboneFormView
  , MessageView
  ,	_
  ,	jQuery
  , Utils
  ,	MyOrganisationSS2Model

  )
{
  'use strict';

    return Backbone.View.extend({
           
        template: nvt_myassociatemulorg_address_tpl

    ,   title: Utils.translate('Billing Address')

    ,   initialize: function(options)
            {
                this.options = options;
                this.application = options.application;
                this.page_header = "Billing Address";	
                this.modalClass ='modal-md';  
                var self = this;
                BackboneFormView.add(this);
            }

    ,   events: 
            {
                'keyup #in-modal-zip': 'pincodeapicsall',
                'submit form': 'saveTheForm',
                'input [name="fullname"]': 'forceUppercase',
                'input [name="addr1"]': 'forceUppercase',
                'input [name="addr2"]': 'forceUppercase',
                'input [name="addr3"]': 'forceUppercase',
                'input [name="city"]': 'forceUppercase'
            }   
            
     ,   forceUppercase: function (e)
            {
                var el = e.target;
                var pos = el.selectionStart;
                el.value = el.value.toUpperCase();
                el.setSelectionRange(pos, pos);
            }

    ,   validateEmail : function (email) {
                var self = this;
                var re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
                return re.test(email);
            }

    ,   saveTheForm: function(e)
            {
                e.preventDefault();
                e.stopImmediatePropagation();
                var self = this,
                	$target = jQuery(e.target),
			    	getfielddata = $target.serializeObject();
                    
                if (getfielddata.fullname) {
                    getfielddata.fullname = getfielddata.fullname.toUpperCase();
                    $target.find('[name="fullname"]').val(getfielddata.fullname);
                }

                if(!getfielddata.fullname && !getfielddata.fullname.trim())
                {
                    self.showMessage('Bill-To Name is required', 'error','fullname');
                }
                else if(!getfielddata.zip && !getfielddata.zip.trim() || getfielddata.zip.length < 5 )
                {
                    self.showMessage('Zip code is required', 'error','zip');
                }
                else if(!getfielddata.addr1 && !getfielddata.addr1.trim())
                {
                    self.showMessage('Block No/ Building No/ Street Name', 'error','addr1');
                }
                else if(!getfielddata.addr2 && !getfielddata.addr2.trim())
                {
                    self.showMessage('Unit Number is required', 'error','addr2');
                }
                else if(!getfielddata.addr3 && !getfielddata.addr3.trim())
                {
                    self.showMessage('Building Name is required', 'error','addr3');
                }
                // else if(getfielddata.phone =='' || getfielddata.phone.length < 8)
                // {
                //     self.showMessage('Contact number is required', 'error','phone');
                // }
                else if(getfielddata.country == '')
                {
                    self.showMessage('Country is required.', 'error','country');  
                }
                // else if(getfielddata.state == '')
                // {
                //     self.showMessage('State is required.', 'error','state');  
                // }
                else
                    {
                        var promise = BackboneFormView.saveForm.apply(this, arguments);
                        this.$containerModal.addClass('fade').modal('show').data('bs.modal', null);
                        return promise && promise.then
                        (
                            function(responce)
                            {
                                if (responce.successMessage)
                                {
                                    self.showMessage(responce.successMessage, 'success');
                                }
                                else {
                                    self.showMessage(responce.errorMessage, 'error')
                                }

                                return false;   
                            }
                        );
                    }              
               
            }

    ,   showMessage: function(message, type, field)
            {
                jQuery('.global-views-message-error').remove(); 
                jQuery('.global-views-message-success').remove(); 

                var messageView = new MessageView
                ({
                        message: message
                    ,   type: type
                    ,   closable: type =='error' ? true : false
                });
                if (typeof field !== 'undefined')
                {
                    this.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
                }
                else if (type =='error'){
                    this.application.getLayout().$('form').append(messageView.render().$el);
                }
                else
                {
                    this.application.getLayout().$('form').empty().html(messageView.render().$el);       
                    setTimeout(function() {
                        jQuery("[data-dismiss=modal]").trigger({ type: "click" });
                    }, 1000);
                }
            }    
            

    ,	pincodeapicsall : function(e)
		{
			e.preventDefault();
			var $target = jQuery(e.target);
			var getpincode = $target.val();
			var self = this;
			if(getpincode.length > 5)
			{
				this.models = new MyOrganisationSS2Model();
				this.models.fetch({async: false,data: {
				   'getmethod':'pincodeAPICall',
				   'getpincode': getpincode
				   }}).done(function(result) {
					if(result)
					{
						jQuery("input[name=addr1]").val(result.addr1);
						jQuery("input[name=addr2]").val(result.addr2);
						jQuery("input[name=addr3]").val(result.addr3);
					}				 
					else{
						jQuery("input[name=addr1]").val('');
						jQuery("input[name=addr2]").val('');
						jQuery("input[name=addr3]").val('');
					}
				});				
			}
		}

    ,   getContext: function() {
            
            var self = this;
      
            return {
        
               title : this.title,

               accosiate_id : this.options.cutomuparams || null,

               getinternalid : this.options.profile.billaddress || '',

               fullname : this.options.profile.billaddressee || '',

               zip : this.options.profile.billzipcode || '',

               addr1 : this.options.profile.billaddress1 || '',

               addr2 :  this.options.profile.billaddress2 || '',

               addr3 :  this.options.profile.billaddress3 || '',

               phone  :  this.options.profile.billphone || '',

               city  :  this.options.profile.billcity || '.',

               country  :  this.options.profile.billcountry || '',

               state  :  this.options.profile.billstate || '',
               
           }
         }        

    });
});
